"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchVersion = fetchVersion;

var _ImmutableAPI = require("../api/ImmutableAPI");

var _enviro = _interopRequireDefault(require("enviro"));

function fetchVersion() {
  return (0, _ImmutableAPI.get)("https://app.hubspot" + (_enviro.default.isProd() ? '' : 'qa') + ".com/contacts/crm-ui-version.json");
}